<div class="title-bar title-bar--responsive">
  <div class="title-bar__heading">
    <h1>CONTENT</h1>
    <app-help screen="content"></app-help>
  </div>
</div>

<div class="status-message" aria-live="polite" role="status">
  @if (statusMessage) {
    <span>{{ statusMessage }}</span>
  }
</div>
@if (errorMessage) {
  <div class="error-message" role="alert">
    {{ errorMessage }}
  </div>
}
@if (state == "error") {
  <div class="alert alert-warning" role="alert">An error has occurred attempting to save changes</div>
}

<div class="action-panel" role="region" aria-label="Draft actions" [attr.aria-busy]="isApplyingDraft || isResettingDraft ? 'true' : null">
  @if (ups.draftChanges | async; as hasChanges) {
    <button mat-flat-button color="primary" type="button" (click)="makeChangesLive()" [disabled]="isApplyingDraft || !hasChanges">
      @if (isApplyingDraft) {
        <span>Making Live…</span>
      }
      @if (!isApplyingDraft) {
        <span>Make Changes Live</span>
      }
    </button>
    <button mat-stroked-button color="warn" type="button" (click)="resetDraftToLive()" [disabled]="isResettingDraft || !hasChanges">
      @if (isResettingDraft) {
        <span>Restoring Draft…</span>
      }
      @if (!isResettingDraft) {
        <span>Discard Draft Changes</span>
      }
    </button>
    @if (!hasChanges && !isApplyingDraft && !isResettingDraft) {
      <span class="no-changes"> No draft changes detected. </span>
    }
  }
</div>

<form [formGroup]="contentForm" novalidate>
  <div formGroupName="content">
    <mat-vertical-stepper class="content-stepper" #contentStepper (selectionChange)="onStepperSelectionChange($event.selectedIndex)" [disableRipple]="true">
      <mat-step [completed]="!contentForm.get('content.welcomeIntro')?.dirty">
        <ng-template matStepLabel>Welcome</ng-template>
        <div class="step-form" style="max-width: 800px; margin-left: 1rem">
          <p>School welcome message shown below the estimate call-to-action. A short paragraph works best—the page already introduces the Net Price Calculator.</p>
          <quill-editor appQuillA11y="Welcome introduction content editor for the Net Price Calculator" [modules]="modules" theme="snow" formControlName="welcomeIntro"></quill-editor>
        </div>
        <div class="nav-buttons">
          <button mat-raised-button type="button" (click)="goToNext()" [disabled]="!canGoNext">Next</button>
        </div>
      </mat-step>

      <mat-step [completed]="!contentForm.get('content.welcomeDisclaimer')?.dirty">
        <ng-template matStepLabel>Welcome Notes</ng-template>
        <div class="step-form" style="max-width: 800px; margin-left: 1rem">
          <p>Shown as “Before you begin.” Keep this brief—household, income, savings, and academic plans the student should have ready. Longer notes still display, but shorter copy is easier to scan.</p>
          <quill-editor appQuillA11y="Welcome notes content editor for the Net Price Calculator" [modules]="modules" theme="snow" formControlName="welcomeDisclaimer"></quill-editor>
        </div>
        <div class="nav-buttons">
          <button mat-raised-button type="button" (click)="goToPrevious()" [disabled]="!canGoBack">Back</button>
          <button mat-raised-button type="button" (click)="goToNext()" [disabled]="!canGoNext">Next</button>
        </div>
      </mat-step>

      <mat-step [completed]="!contentForm.get('content.nextSteps')?.dirty">
        <ng-template matStepLabel>Next Steps</ng-template>
        <div class="step-form" style="max-width: 800px; margin-left: 1rem">
          <p>Instructions for what the student can do next in the process.</p>
          <quill-editor appQuillA11y="Next steps content editor for the Net Price Calculator" [modules]="modules" theme="snow" formControlName="nextSteps"></quill-editor>
        </div>
        <div class="nav-buttons">
          <button mat-raised-button type="button" (click)="goToPrevious()" [disabled]="!canGoBack">Back</button>
          <button mat-flat-button color="primary" type="button" (click)="save()" [disabled]="!contentForm.valid || state != 'modified'">
            {{ state == "modified" ? "Save Changes" : "No unsaved changes" }}
          </button>
        </div>
      </mat-step>
    </mat-vertical-stepper>
  </div>
</form>
